export default __webpack_public_path__ + "static/media/10-new1.46c1e505.png";